// src\utils\formatters.js
import { format } from "date-fns";

export const formatPhoneNumber = (phone) => {
  if (!phone) return "-";
  const phoneStr = phone.toString();
  if (phoneStr.length === 11) {
    return phoneStr.replace(/(\d{4})(\d{7})/, "$1-$2");
  } else if (phoneStr.length === 10) {
    return phoneStr.replace(/(\d{3})(\d{7})/, "$1-$2");
  }
  return phoneStr;
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "-";
    return format(date, "dd MMM yyyy");
  } catch (error) {
    return "-";
  }
};
